export const logout = (navigate) => {
    sessionStorage.clear();
    window.onbeforeunload = {};
    localStorage.clear();
    if (typeof navigate === "function") navigate("/");
    else window.location.reload();
};
